<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="3" width="8" height="2" fill="var(--icon-color)" />
    <rect x="6" y="7" width="8" height="2" fill="var(--icon-color)" />
    <rect x="6" y="11" width="8" height="2" fill="var(--icon-color)" />
    <rect x="2" y="3" width="2" height="2" fill="var(--icon-color)" />
    <rect x="2" y="7" width="2" height="2" fill="var(--icon-color)" />
    <rect x="2" y="11" width="2" height="2" fill="var(--icon-color)" />
</svg>
